<template>
  <div class="menu s-center full">
    <sw-input
      ref="name"
      name="name"
      label="Nom du template"
      class="form-template-input center-y ml-50"
      @input="inputHandler($event)"
      autocomplete="off"
    />
    <sw-button
      label="valider"
      class="button-valid-form center"
      @click="validTemplate"
      :disabled="!isValid"
    />
    <sw-button class="button-personnal-cancel center" @click="$emit('backMenu')">
      <span>
        ou
        <span style="text-decoration:underline;">annuler</span>
      </span>
    </sw-button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { EventBus, PAYMENT_INFO, TEMPLATE_SAVE } from '@/model/EventBus'

import menu from '../menu-default'
import { lte, defined } from 'junctions-fp'
export default {
  name: 'CreateTemplateMenu',
  mixins: [menu],
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      isValid: false
    }
  },
  props: {
    editor: null
  },
  computed: {
    ...mapGetters(['getFormatList', 'getLimitations', 'templatesList'])
  },
  methods: {
    ...mapActions(['getUserInfo']),
    inputHandler(txt) {
      this.isValid = defined(txt.trim())
    },
    async validTemplate() {
      //await this.getUserInfo()
      if (this.getLimitations.templates === 0) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        return
      }
      const myTemplates = this.templatesList.filter(t => t.public === false)
      if (this.getLimitations.templates <= myTemplates.length && this.getLimitations.templates !== -1) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        return
      }
      EventBus.$emit(TEMPLATE_SAVE, this.$refs.name.getValue().name)
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/template/CreateTemplateMenu.vue